<template>
  <div>
    <PageBanner 
      title="Our Services" 
      imageSrc="../assets/images/rice-7176354_1280.jpg" 
      altText="Services Banner" 
    />
    <Services1Section />
    <Services2Section />
    <Services3Section />
    <Services4Section />
    <Services5Section />
    <!--<Services6Section />-->
    <CallToActionSection />
  </div>
</template>

<script>
import PageBanner from '@/components/PageBanner.vue';
import Services1Section from '@/components/Services1Section.vue';
import Services2Section from '@/components/Services2Section.vue';
import Services3Section from '@/components/Services3Section.vue';
import Services4Section from '@/components/Services4Section.vue';
import Services5Section from '@/components/Services5Section.vue';
//import Services6Section from '@/components/Services6Section.vue';
import CallToActionSection from "@/components/CallToActionSection.vue";


export default {
  name: "ServicesView",
  components: {
    PageBanner,
    Services1Section,
    Services2Section,
    Services3Section,
    Services4Section,
    Services5Section,
    //Services6Section,
    CallToActionSection
  },
};
</script>
